import { createListFilters, IOption } from '../../../../../components'

export type HistoricoFilters = {
  estado?: IOption<number>
  protocolo: string
  /** Solicitação a partir desta data (aaaa-mm-dd). */
  solicitacao: string
}

export const { ListFiltersProvider, useListFilters } = createListFilters<HistoricoFilters>({
  estado: undefined,
  protocolo: '',
  solicitacao: '',
})
